import React from 'react';
import colors from '../Constants/colors';

const Footer = () => {
  return (
    <footer
      className="text-center p-4"
      style={{
        background: colors.gradientPrimary, 
        color: colors.primaryText,        
      }}
    >
      &copy; 2024 Gurukul 2.0. All rights reserved.
    </footer>
  );
};

export default Footer;
